import { Injectable } from '@angular/core';

/**
 *  Abstract class to be extended by any media storage provider.
 */
@Injectable()
export abstract class MediaStorageService {
    /**
     * Delete file in the storage
     * @param url File url to delete
     */
    abstract delete(url: string): Promise<void>;

    /**
     * Get media content type for the file in the given url
     *
     * @param url Url/path to media
     * @returns Media content type
     */
    abstract getMediaType(url: string): Promise<'image' | 'video'>;

    /**
     * Replace file in the storage
     *
     * @param file File to be uploaded
     * @param url File url to replace
     * @returns Destination file url
     */
    abstract replace(file: File, url: string): Promise<string>;

    /**
     * Upload file to the storage
     *
     * @param endpoint Url/path where the media should be uploaded
     * @param file File to be uploaded
     * @returns Destination file url
     */
    abstract upload(file: File, endpoint: string): Promise<string>;

    /**
     * download the file from storage
     * @param fileUrl the url of the file in the storage
     * @param filename the name of the downloaded file
     */
    abstract download(fileUrl: string, filename: string): Promise<void>;
}
